import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

type B2CModeState = {
  mode: Mode;
  changeMode: (mode: Mode) => void;
};

export const useB2CModeStore = create<B2CModeState>()(
  persist(
    immer((set) => ({
      mode: 'blockchain',
      changeMode: (mode: Mode) => {
        set((state) => {
          state.mode = mode;
        });
      },
    })),
    {
      name: 'coinraces-b2c-mode-storage',
      partialize: (state) => ({ mode: state.mode }),
      onRehydrateStorage: () => (state) => {
        // Force blockchain mode on every load, ignoring saved state
        if (state) {
          state.mode = 'blockchain';
        }
      },
    }
  )
);

type Mode = 'blockchain' | 'demo' | 'tournament';

export type B2CMode = Mode;
